import styles from "./textArea.module.css";

const TextArea = ({ placeHolder, value, onChange, rows }) => {
  return (
    <textarea
      className={styles.textArea}
      rows={rows ? rows : "5"}
      cols="100"
      onResize={null}
      value={value}
      onChange={(e) => onChange(e)}
      placeholder={placeHolder}
    />
  );
};

export default TextArea;
